var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrepaidDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_224_744)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4274 27.179H19.0928L17.1608 24.8586H14.18L12.248 27.179H10.8097C10.6631 27.179 10.5443 27.2979 10.5443 27.4444C10.5443 27.591 10.6632 27.7099 10.8097 27.7099H20.4274C20.574 27.7099 20.6928 27.591 20.6928 27.4444C20.6928 27.2979 20.5739 27.179 20.4274 27.179Z",
    fill: "url(#paint1_linear_224_744)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3744 14.4769V9.91113H7.91113V22.4166H21.7788V15.5385C21.7788 14.9531 22.2551 14.4768 22.8405 14.4768L23.3744 14.4769Z",
    fill: "url(#paint2_linear_224_744)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38031 22.6821V9.64574C7.38031 9.49913 7.49918 9.38031 7.64574 9.38031H23.6399C23.7864 9.38031 23.9053 9.49918 23.9053 9.64574V14.4769H25.2856V8.90296C25.2856 8.40503 24.8805 8 24.3826 8H6.90301C6.40508 8 6 8.40503 6 8.90296V23.4249C6 23.9228 6.40508 24.3278 6.90301 24.3278H21.7789V22.9475H7.64574C7.49913 22.9476 7.38031 22.8287 7.38031 22.6821Z",
    fill: "url(#paint3_linear_224_744)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0619 15.6554H27.5623C27.9149 15.6554 28.2029 15.3665 28.2121 15.0078H24.412C24.4212 15.3664 24.7092 15.6554 25.0619 15.6554Z",
    fill: "url(#paint4_linear_224_744)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7836 15.0078H28.7428C28.7333 15.6592 28.2075 16.1862 27.5622 16.1862H25.0618C24.4165 16.1862 23.8908 15.6592 23.8813 15.0078H22.8405C22.5477 15.0078 22.3097 15.2459 22.3097 15.5386V28.4693C22.3097 28.7619 22.5478 29 22.8405 29H29.7836C30.0763 29 30.3143 28.7619 30.3143 28.4693V15.5386C30.3144 15.2459 30.0763 15.0078 29.7836 15.0078ZM27.2038 28.257H25.4203C25.2737 28.257 25.1548 28.1381 25.1548 27.9915C25.1548 27.845 25.2737 27.7261 25.4203 27.7261H27.2038C27.3504 27.7261 27.4692 27.845 27.4692 27.9915C27.4693 28.1382 27.3504 28.257 27.2038 28.257Z",
    fill: "url(#paint5_linear_224_744)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_744",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CCF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_744",
    x1: 19.9733,
    y1: 25.3735,
    x2: 8.80719,
    y2: 26.6694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_744",
    x1: 22.2781,
    y1: 12.1694,
    x2: 5.06312,
    y2: 12.8634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_744",
    x1: 23.9183,
    y1: 10.9485,
    x2: 2.44494,
    y2: 11.7754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_744",
    x1: 27.9427,
    y1: 15.1247,
    x2: 23.8549,
    y2: 15.9069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_224_744",
    x1: 29.7468,
    y1: 17.5345,
    x2: 20.824,
    y2: 17.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrepaidDashboard);
export default __webpack_public_path__ + "static/media/prepaid-dashboard.1c40a33aefa1d450f6ea10d6df661005.svg";
export { ForwardRef as ReactComponent };